import {CToaster} from "@coreui/react";
import Message from "../component/Message";
import {Col, Container, Row} from "react-bootstrap";
import * as React from "react";
import {useRef, useState} from "react";
import logirocLogo from "../assets/Images/logo/logirocblacktransparent.png";
import Image from "react-bootstrap/Image";

export const InscriptionContainer = ({children}) => {

    const INITIAL_STATE = {
        username: "",
        firstname: "",
        email: "",
        password: ""
    }

    const [hasError, setHasError] = useState(false);
    const [mailError, setMailError] = useState();
    const [erreur, setErreur] = useState('');
    const [modal, setModal] = useState({
        show: false,
        title: "",
        content: [""],
        error: false
    });
    // States for registration
    const [form, setForm] = React.useState(INITIAL_STATE);
    const [loading, setLoading] = useState(false);
    // States for checking the errors
    const [submitted, setSubmitted] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [toast, addToast] = useState(0);
    /*** password toogle hide show */
    const toaster = useRef()

    const fontWeightTitle = {
        fontWeight: "600"
    };
    const onHide = () => {
        // Mettez à jour l'état du modal pour le masquer ou réinitialisez les données
        setModal({show: false, content: []});
    };
    const autoScreenheight = {
        height: "100vh"
    }
    const logocolor = {
        color: "#3F50B6"
    }

    return (
        <div className="form pt-0 w-100 m-auto">
            <CToaster ref={toaster} push={toast} placement="top-end"/>
            <Message show={modal?.show} onHide={onHide} data={modal}/>

            <div
                className="d-flex align-items-center flex-wrap justify-content-center"
                style={autoScreenheight}
            >
                <div>
                    <h2
                        className="text-center fs-1 mb-5 mx-5"
                        style={Object.assign(logocolor, fontWeightTitle)}
                    >
                        <Image style={{maxWidth: "200px"}} src={logirocLogo}></Image>
                    </h2>
                    <Container
                        className="container-fluid d-flex align-items-center wrap justify-content-center inscription-container">
                        <Row
                            className="bg-white px-0"
                            style={{
                                borderRadius: "8px",
                                boxShadow: "1px 1px 10px 1px rgba(0, 0, 0, 0.03)",
                                height: "auto",
                            }}
                        >
                            <Col className="bg-image-auth d-none-xs "></Col>
                            <Col
                                className="col h-100 pe-4 py-lg-0 p-md-4 p-sm-5 p-4 my-3 mx-4 my-lg-0 my-sm-3 bg-white mx-lg-0 mx-sm-4 rounded">
                                {children}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </div>
    )
}